/**
 * TanStack Query hooks for `linkedin-ads-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	linkedinAdsIntegrationQueryKeys,
	type CreateLinkedinAdsIntegrationBody,
	type ListLinkedinAdsIntegrationResponse,
	type LinkedinAdsIntegrationRow,
} from "./api";

export function useLinkedinAdsIntegrationList(): UseQueryResult<ListLinkedinAdsIntegrationResponse, Error> {
	return useQuery({
		queryKey: linkedinAdsIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useLinkedinAdsIntegrationCreate(): UseMutationResult<LinkedinAdsIntegrationRow, Error, CreateLinkedinAdsIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkedinAdsIntegrationQueryKeys.all });
		},
	});
}

export function useLinkedinAdsIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkedinAdsIntegrationQueryKeys.all });
		},
	});
}
